import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WebMenuNode } from 'app/com/ibm/tw/commons/beans/web.menu.node';
import { AppParamType } from 'app/com/ibm/tw/commons/enums/global/appparam.type';
import { MessageType } from 'app/com/ibm/tw/commons/enums/global/message.type';
import { TaskViewForm } from 'app/com/ibm/tw/commons/mvc/task.viewform';
import { CommonPopupMessageViewForm } from 'app/pagecode/commonpage/message/common.popup.message.viewfrom';
import { ShareService } from 'app/services';
import { Observable, Subscription } from 'rxjs';
import { EventData, Item, StatusService } from 'ui-components/common';
import { ValidatorService } from 'ui-components/validator';
import { AxthenticationService } from '../../../../services/axthentication.service';
import { CcmotlginhomeViewForm } from '../../../cot/ccmotlgin/home/ccmotlgin.home.viewform';
import { SingleBrowserUtils } from './../../../../com/ibm/tw/commons/utils/single.browser.utils';
import { TxnService } from './../../../../services/txn.service';
import { CcmhmannoHomeViewForm } from './ccmhmanno.home.viewform';
import { CtwdllinkViewForm } from './ctwdllink/ctwdllink.viewform';
import { CtwflcnbkViewForm } from './ctwflcnbk/ctwflcnbk.viewform';
import { RedirectService } from './redirect.service';

declare var jQuery: any;
declare var gibmsg: any;

@Component({
    standalone: false,
    templateUrl: 'ccmhmanno.home.component.html'
})

export class CcmhmannoHomeComponent implements OnInit, AfterViewInit, OnDestroy {

    messageSubscription: Subscription;

    viewForm: CcmhmannoHomeViewForm;

    mainMenu: WebMenuNode = null; // 主選單

    /** 使用者可使用區域清單. */
    userAreaOptions: Item[];

    /** 目前的地區  */
    currentArea: string;

    /** 目前的語系  */
    currentLangItem: Item;

    /** 使用者可使用的語系. */
    languageOptions: Item[];

    /** 目前的地區名稱  */
    areaName: string;

    /** 是否點擊了header的mb menu 事件 */
    clickheader: boolean = false;

    /** GIB-9217 提示訊息Popup */
    cpmViewForm: CommonPopupMessageViewForm;

    /** GIB-9217 共用Popup顯示Flag */
    public showCPMFlag: boolean = false;

    constructor(private router: Router,
        private axthenticationService: AxthenticationService,
        private validatorService: ValidatorService,
        public shareService: ShareService,
        public txnService: TxnService,
        public statusService: StatusService, private redirectService: RedirectService) { }


    ngOnInit() {
        // 將Menu的值取出

        this.onResize(null);

        // 成功回呼方法
        let logoutCall = () => {
            // 因為是同一個瀏覽器中的不同tab將自已登出，所以不可以再呼叫server進行登出
            this.router.navigateByUrl('/login');
        }

        // 進行瀏覽器中的單一使用者鎖定
        let singleBrowserUtils: SingleBrowserUtils = new SingleBrowserUtils(false, 'pfmtimelock', 5, logoutCall);
        singleBrowserUtils.lock();
        singleBrowserUtils.repeatCheck();

        this.viewForm = this.txnService.getViewForm<CcmhmannoHomeViewForm>('ccmhmannohome');

        this.mainMenu = this.axthenticationService.menu;

        this.currentArea = this.axthenticationService.currentArea;

        this.userAreaOptions = this.axthenticationService.userAreaOptions;

        let currentAreaItem: Item = this.userAreaOptions.find(this.findCurrentAreaItem.bind(this));

        this.areaName = currentAreaItem.label;

        this.languageOptions = this.txnService.getLangOptions();

        this.currentLangItem = this.languageOptions.find(this.findCurrentLangItem.bind(this));

        this.doChangeLangClass(this.currentLangItem.value);

        this.axthenticationService.resetTimer();

        this.statusService.hide();

    }

    /**
     * 取得目前的語系
     */
    findCurrentLangItem(option: Item) {
        return option.value === this.txnService.getCurrentLang();
    }

    menuClick(event: EventData): void {
        if (event.value == null || event.value === undefined) {
            event.value = event.taskID.toLowerCase();
        } else {
            event.value = event.value.toLowerCase();
        }

        let taskViewForm = new TaskViewForm();
        taskViewForm.navigatePage = event.taskID.toLowerCase();

        if (taskViewForm.navigatePage === 'ctwdllink') {
            this.ssoLogin();
            return;
        }

        // GIB-9217 中國子行快速登入服務
        if (taskViewForm.navigatePage === 'ctwflcnbk') {
            this.cnbkLogin();
            return;
        }


        taskViewForm.basePath = event.value.substring(0, event.value.lastIndexOf('.'));

        let clickmenu: WebMenuNode = event.originalEvent as WebMenuNode;

        taskViewForm.gibCurrentArea = clickmenu.areaType;

        this.validatorService.clearAllTooltip();

        this.axthenticationService.doInitPage(taskViewForm, this.statusService);
    }

    areaSelect(event: EventData): void {
        // console.log('areaSelect..' + JSON.stringify(event));

        this.statusService.show();

        let nextView: CcmotlginhomeViewForm = new CcmotlginhomeViewForm();

        nextView.gibCurrentArea = event.value;

        let response: Observable<CcmhmannoHomeViewForm> = this.axthenticationService.doChangeArea(nextView);

        // this.axthenticationService.currentArea = event.value;

        this.doUpdateMenuAndArea();

        response.subscribe(result => {

            // GIB-3801 設定 doErrorLogFlag 參數
            this.shareService.setAppParam(AppParamType.DOERRORLOG_FLAG, result.doErrorLogFlag);
            this.gotoTaskPage(result);

        },
            err => {
                // GIB-3801 設定 doErrorLogFlag 參數
                if (err.doErrorLogFlag !== undefined) {
                    this.shareService.setAppParam(AppParamType.DOERRORLOG_FLAG, err.doErrorLogFlag);
                }
                this.axthenticationService.goToErrorPage(err);
            });

    }

    languageSelect(event: EventData): void {

        this.validatorService.clearAllTooltip();

        gibmsg = undefined;

        let lang = event.value;

        this.txnService.setCurrentLangJson(lang, this.doChangeLanguage.bind(this));

    }

    doChangeLanguage() {

        // console.log('換語言到' + lang);

        let lang = this.txnService.getCurrentLang();

        console.log('getCurrentLang===' + lang);

        let langViewForm = new CcmotlginhomeViewForm();

        langViewForm.selectedLocale = lang;

        this.doChangeLangClass(lang);

        let response: Observable<CcmhmannoHomeViewForm> = this.axthenticationService.doChangeLanguage(langViewForm);

        response.subscribe((result: CcmhmannoHomeViewForm) => {


            // GIB-3801 設定 doErrorLogFlag 參數
            this.shareService.setAppParam(AppParamType.DOERRORLOG_FLAG, result.doErrorLogFlag);

            this.languageOptions = result.languageOptions;

            this.txnService.setLangOptions(result.languageOptions);

            this.gotoTaskPage(result);

        }, err => {

            // GIB-3801 設定 doErrorLogFlag 參數
            if (err.doErrorLogFlag !== undefined) {
                this.shareService.setAppParam(AppParamType.DOERRORLOG_FLAG, err.doErrorLogFlag);
            }
            this.txnService.goToErrorPage(err);

        });
    }

    /**
     * 用不同的語系，有不同的body class
     */
    private doChangeLangClass(lang) {

        if (lang === undefined) {
            return;
        }

        if (lang === 'en_US') {
            this.addClass(document.body, 'en');
        } else {
            if (this.hasClass(document.body, 'en')) {
                this.removeClass(document.body, 'en');
            }
        }
    }


    public addClass(element: any, className: string): void {
        if (element === undefined || element === null) {
            return;
        }
        if (element.classList) {
            element.classList.add(className);
        } else {
            element.className += ' ' + className;
        }
    }

    /**
     * has css style class
     * @param element element
     * @param className class name
     * @returns {boolean} has class
     */
    public hasClass(element: any, className: string): boolean {
        if (element === undefined || element === null) {
            return false;
        }

        if (element.classList) {
            return element.classList.contains(className);
        } else {
            return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
        }
    }

    /**
     * remove css style class
     * @param element element
     * @param className class name
     */
    public removeClass(element: any, className: string): void {
        if (element === undefined) {
            return;
        }
        if (element.classList) {
            element.classList.remove(className);
        } else {
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }


    /**
     * 取得目前的地區選項
     */
    findCurrentAreaItem(option: Item) {
        return option.value === this.currentArea;
    }



    gotoTaskPage(result: CcmhmannoHomeViewForm) {

        // console.log('result................' + JSON.stringify(result));

        this.axthenticationService.menu = result.menu;
        let isSamePage: boolean = false;
        // console.log('this.currentMenuId===' + this.axthenticationService.currentMenuId + ',result.taskId,' + result.taskId);
        if (this.axthenticationService.currentMenuId === result.taskIxd) {
            isSamePage = true;
        }

        // alert('result.taskIxd==' + result.taskIxd);
        this.axthenticationService.currentMenuId = result.taskIxd;
        // console.log(' this.axthenticationService.currentMenuId===' + this.axthenticationService.currentMenuId);

        // 預設的timeout時間
        if (result.timeoutSecond > 0) {
            this.axthenticationService.defaultTimeoutSecond = result.timeoutSecond;
        }

        // 將登入後取得的token放至axthenticationService
        this.axthenticationService.token = result.token;

        // console.log('defaultTimeoutSecond....' + this.axthenticationService.defaultTimeoutSecond);
        // this.axthenticationService.isLoggedIn = result.loggedIn;

        // alert(' result.gibCurrentArea===' + result.gibCurrentArea);
        this.axthenticationService.currentArea = result.gibCurrentArea;
        this.axthenticationService.userAreaOptions = result.userAreaOptions;
        this.axthenticationService.welcomePage = result.basePath + '.' + result.navigatePage;

        this.axthenticationService.setToken(result.token);
        this.axthenticationService.taskUrl = result.taskUrl;

        if (result.welcomeBean) {

            // alert('result.welcomeBean=' + result.welcomeBean);
            this.axthenticationService.historyList = result.welcomeBean.accessLogList;
            // console.log(' this.axthenticationService.historyList===' + this.axthenticationService.historyList);
            this.axthenticationService.favoriteTaskList = result.welcomeBean.favoriteTaskList;
            // console.log(' this.axthenticationService.welcomePage=' + JSON.stringify(this.axthenticationService.welcomePage));
        }

        this.statusService.taskIxd = result.taskIxd;

        // 更新交易的前端語系
        this.txnService.insertTaskLanguage(result.navigatePage);

        // console.log('addHistory...');
        // 先將目前的viewform 儲存下來
        this.txnService.addHomeHistory(result);

        // console.log('goto next page...' + isSamePage);

        this.doUpdateMenuAndArea();

        this.axthenticationService.gotoTaskPage(result);

        if (isSamePage) {
            this.statusService.hide();
        }

    }
    /**
     * 按鈕事件進行切換.
     */
    doClickMbMenu() {
        // console.log('doClickMbMenu..........');
        this.clickheader = !this.clickheader;
    }

    doCloseMbMenu() {
        // console.log('doCloseMbMenu..........');
        this.clickheader = !this.clickheader;
    }
    doClientHome() {
        // console.log('doClientHome..........');
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        // console.log('onResize..........' + event);
        let $html = jQuery('html');

        // test
        if (innerWidth < 767) { // 用window.innerwidth代替$window.width()
            // $("#nav_mega_menu").addClass('hidden-sm');
            jQuery('#nav_mega_menu').hide();
            return $html.addClass('mobile');
        } else {
            jQuery('#nav_mega_menu').show();
        }

        // ib版 拿掉項目
        $html.removeClass('mobile');
        jQuery('#nav_mega_menu').children().removeClass('func_navigation');
        jQuery('#nav_mega_menu').addClass('nav_mega_menu');
    }

    ngAfterViewInit(): void {
        this.messageSubscription = this.statusService.messageSource$.subscribe(
            message => {
                if (message.for === MessageType.UPDATE_MENU) {
                    this.doUpdateMenuAndArea();
                } else if (message.for === MessageType.UPDATE_HEADER_AREA) {
                    this.doUpdateMenuAndArea();
                }
            }
        )
    }

    /**
     * 更新menu 和 area
     */
    doUpdateMenuAndArea() {

        // console.log(this.axthenticationService.menu);
        this.mainMenu = this.axthenticationService.menu;
        this.currentArea = this.axthenticationService.currentArea;
        let currentAreaItem: Item = this.userAreaOptions.find(this.findCurrentAreaItem.bind(this));
        this.areaName = currentAreaItem.label;
    }

    ngOnDestroy() {
        if (this.messageSubscription) {
            this.messageSubscription.unsubscribe();
        }
    }


    /**
     * sso login.
     */
    ssoLogin(): void {
        let ssoViewForm: CtwdllinkViewForm = new CtwdllinkViewForm();
        ssoViewForm.basePath = 'pagecode.cdl.ctwdllink';
        ssoViewForm.gibCurrentArea = 'TW';

        let response = this.axthenticationService.doPostToBackEnd<CtwdllinkViewForm>(ssoViewForm, ssoViewForm, '/ctwdllinkhome/ssoLogin');
        response.subscribe(result => {
            // GIB-3801 設定 doErrorLogFlag 參數
            this.shareService.setAppParam(AppParamType.DOERRORLOG_FLAG, result.doErrorLogFlag);
            this.openSsoPopup(result.step2Url, result.token);
        },
            err => {
                // GIB-3801 設定 doErrorLogFlag 參數
                if (err.doErrorLogFlag !== undefined) {
                    this.shareService.setAppParam(AppParamType.DOERRORLOG_FLAG, err.doErrorLogFlag);
                }
                this.openErrorSsoPopup(err);
            });
    }

    protected openErrorSsoPopup(error: object): void {
        console.log('error -->  ' + error);
        // let width = 800;
        // let height = 600;
        // let wLeft = window.screenLeft ? window.screenLeft : window.screenX;
        // let wTop = window.screenTop ? window.screenTop : window.screenY;
        // let left = wLeft + (window.innerWidth / 2) - (width / 2);
        // let top = wTop + (window.innerHeight / 2) - (height / 2);

        // let specs = 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width='
        //   + width.toString() + ', height=' + height.toString() + ', top=' + top.toString() + ', left=' + left.toString();
        let win = window.open('', '_blank');
        if (!win) {
            return
        }

        let html = '';
        if (error) {
            console.log('err:' + JSON.stringify(error) + ',' + typeof (error));
            html += error['errorDesc'];
        }
        win.document.write(html);
    }

    /**
     * 開啟國內狀SSO popup.
     */
    protected openSsoPopup(step2Url: string, token: string): void {
        let param = { VerifyToken: token };
        let url: string = step2Url;
        // https://esbt.esunbank.com.tw/CIB2B2C/GIBPreSSOServlet/doSSOLoginAction
        this.redirectService.post(param, url);

    }

    /**
     * GIB-9217 中國子行快速連結服務.
     */
    cnbkLogin(): void {

        let cnViewForm: CtwflcnbkViewForm = new CtwflcnbkViewForm();
        cnViewForm.basePath = 'pagecode.cfl.ctwflcnbk';
        cnViewForm.gibCurrentArea = 'TW';

        let response = this.axthenticationService.doPostToBackEnd<CtwflcnbkViewForm>(cnViewForm, cnViewForm, '/ctwflcnbkhome/doLogin');
        response.subscribe(result => {
            // 開新視窗登入
            window.open(result.loginUrl, '_blank');
        },
            err => {
                this.showPopup(err);
            });
    }

    /**
     *  GIB-9217 中國子行快速連結服務 popup
     */
    public showPopup(error: object): void {

        let errDesc = '';

        if (error) {
            // 產生錯誤訊息
            console.log('err:' + JSON.stringify(error) + ',' + typeof (error));
            errDesc += error['errorDesc'];
            errDesc += "[" + error['systemIxd'];
            errDesc += "-" + error['errorCode'] + "]";

            this.cpmViewForm = new CommonPopupMessageViewForm();
            this.cpmViewForm.title = this.txnService.transform('提示訊息', 'common00000987', null);
            this.cpmViewForm.showMessage = errDesc;
            // '關閉' 按鈕改為 '確定'
            this.cpmViewForm.simpleDes = this.txnService.transform('確定', 'Confirm', null);
            this.cpmViewForm.isConfirm = false;
            // 開啟提示 popup
            this.showCPMFlag = true;
        }
    }

    /**
     * GIB-9217 共用電文提示 popup callBack
     */
    public doPopupCallBack() {
        this.showCPMFlag = false;
    }
}
